import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import React from 'react';

const MobileLoggedInNavbar = ({ info }: { info: any }) => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  return (
    <div>
      <div className="space-y-2 py-6">
        <Link 
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
          data-te-nav-link-ref 
          data-te-ripple-init 
          data-te-ripple-color="light"
          onClick={() => info(false)} 
          to="/dashboard">{t('Dashboard')}</Link>

        <Link 
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
          data-te-nav-link-ref 
          data-te-ripple-init 
          data-te-ripple-color="light"
          onClick={() => info(false)} 
          to="/profile">{t('Profile')}</Link>

        <Link 
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
          data-te-nav-link-ref 
          data-te-ripple-init 
          data-te-ripple-color="light"
          onClick={() => info(false)} 
          to="/settings/get_gck">{t('Settings')}</Link>

        <Link 
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
          data-te-nav-link-ref 
          data-te-ripple-init 
          data-te-ripple-color="light" 
          onClick={() => info(false)} 
          to="/contact/messages">{t('Messages')}</Link>  

          <Link 
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50" 
          data-te-nav-link-ref 
          data-te-ripple-init 
          data-te-ripple-color="light" 
          onClick={() => info(false)} 
          to="/admin/backup">{t('Admin')}</Link> 
      </div>
    </div>
  )
};

export default MobileLoggedInNavbar;
